import OT from '@opentok/client';
import * as getStatsAnalyzer from 'providers/video/common/lib/webrtc-stats-analyzer';
import { RootScopeEvents } from '../../../common/services/root-scope-types';
import * as localMedia from '../../../modules/local-media';
export default class OTSession {
    /* @ngInject */
    constructor($rootScope, $q, $log, $ngRedux) {
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$log = $log;
        this.$ngRedux = $ngRedux;
        this.streams = [];
        this.uniqueStreams = {
            camera: [],
            screen: [],
        };
        this.connections = [];
        this.subscribers = [];
        this.ui = {
            hasAudio: true,
            hasVideo: true,
        };
        getStatsAnalyzer.watchPublishers($rootScope);
        $ngRedux.dispatch(localMedia.actions.setMediaState(this.ui));
    }
    init(apiKey, sessionId, token, options) {
        this.session = OT.initSession(apiKey, sessionId, options);
        this.session.on({
            sessionConnected: (event) => {
                this.$log.debug('OTSession:sessionConnected', event);
                if (this.publisher) {
                    this.session.publish(this.publisher);
                }
            },
            streamCreated: (event) => {
                this.$log.debug('OTSession:streamCreated', event);
                this.$rootScope.$digest();
            },
            connectionDestroyed: (event) => {
                this.$log.debug('OTSession:connectionDestroyed', event);
                this.$rootScope.$digest();
            },
        });
        return this.$q((resolve, reject) => {
            this.session.connect(token, (err) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(this.session);
            });
        });
    }
    initPublisher(element, properties, cb) {
        this.$log.debug('OTSession:initPublisher', event);
        const publisher = OT.initPublisher(element, properties, (err) => {
            cb(err);
            if (!err) {
                this.$rootScope.$emit(RootScopeEvents.SESSION.PUBLISHER_CREATED, publisher);
                publisher.on('streamCreated', ({ stream }) => {
                    this.$rootScope.$emit(RootScopeEvents.SESSION.PUBLISHER_STREAM_CREATED, stream);
                });
                publisher.once('destroyed', () => {
                    this.$rootScope.$emit(RootScopeEvents.SESSION.PUBLISHER_DESTROYED, publisher);
                });
            }
        });
        return publisher;
    }
    isSessionConnected() {
        return Boolean(this.session?.connected ?? this.session?.isConnected());
    }
    togglePublishersAudio(condition) {
        const hasAudio = typeof condition === 'boolean' ? condition : !this.ui.hasAudio;
        this.updateUI({ hasAudio });
        this.publisher?.publishAudio(this.ui.hasAudio);
    }
    togglePublishersVideo(condition) {
        const hasVideo = typeof condition === 'boolean' ? condition : !this.ui.hasVideo;
        this.updateUI({ hasVideo });
        this.publisher?.publishVideo(this.ui.hasVideo);
        // Fix black screen for Safari
        if (!this.ui.hasVideo) {
            return;
        }
        const videoElement = this.publisher?.videoElement();
        if (videoElement?.paused) {
            videoElement.play().catch((e) => {
                console.error('togglePublishersVideo-play', e);
            });
        }
    }
    updateUI(changes) {
        Object.assign(this.ui, changes);
        this.$ngRedux.dispatch(localMedia.actions.setMediaState(changes));
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.TOGGLE_MEDIA, changes);
    }
    resetPublishers() {
        this.togglePublishersAudio(true);
        this.togglePublishersVideo(true);
        this.$rootScope.$evalAsync();
    }
    disconnect() {
        if (!this.isSessionConnected()) {
            return;
        }
        this.$log.debug('OTSession:disconnect', this.publisher);
        if (this.publisher) {
            this.session.unpublish(this.publisher);
        }
        if (this.screensharePublisher) {
            this.session.unpublish(this.screensharePublisher);
        }
        this.session.disconnect();
    }
}
